<div id="team-dialog-container" #form>
  <header>
    <div class="title">
      {{title}}
    </div>

    <div class="close-icon" (click)="close()">
      <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
    </div>
  </header>

  <section class="body">
    <form [formGroup]="teamForm" class="team-form">
      <div>{{'servicePersonnel.name'| translate}}</div>
      <mat-form-field appearance="outline">
        <input matInput placeholder="{{'teamManagement.enterTeamName'| translate}}" formControlName='name' (input)="checkTeamName($event)">
        <mat-error *ngIf="teamForm?.controls?.name?.errors?.required" [innerHTML] = "'teamManagement.nameIsRequired'| translate">
          
        </mat-error>
        <mat-error *ngIf="teamForm?.controls?.name?.errors?.nameInvalid">{{'teamManagement.cannotCreateATeamNamesTxm' | translate}}</mat-error>
      </mat-form-field>
        <div class="color-label mt-2">{{'teamManagement.colorOfTeam'| translate}}</div>
        <div class="row mt-2" style="margin: 0px;">
        <div class="colors" *ngFor='let color of colors' (click)='setTeamColor(color)'  [ngClass]="{'selected' : teamForm.get('teamColor').value === color }" [ngStyle]='{"background-color": color}'>
          <span class="checked-icon" *ngIf="((teamColors$ | async).includes(color) && (color !== this.data?.teamColor))"> <asp-icon name="checked.svg"
            width="1rem" color="#919191" ></asp-icon></span>
        </div>
        <div class="error-msg" *ngIf='isSelectedColor'>{{'teamManagement.chooseTeamColor' | translate}}</div>
      </div>
    </form>
  </section>


<div class="action-button mt-2" style="width: 100%;margin-left: 3rem;"> <button class="asp-btn asp-btn-primary save-button"
            (click)="onActionClicked()"
            [ngClass]="{'asp-btn-disabled' : !teamForm.valid}" style="width:70%;background-color: var(--primary-toyota-color);">
      <span>{{actionText}}</span>
    </button></div>
    <footer>
      <div style="width: 80%;">   <button class="asp-btn asp-btn-secondary cancel-button" (click)="close()">
      <span>{{'overrideCapacity.cancel'| translate}}</span>
    </button></div>
  </footer>
  <h6 *ngIf="clickedOutside" style="color:red;margin:auto;">
  <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
  {{'servicePersonnel.alertCancleMessage'| translate}}</h6>
</div>
